import React from 'react';
import { Settings, Monitor, Globe, Bell } from 'lucide-react';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import AppearanceSettings from '../components/preferences/AppearanceSettings';
import RegionalSettings from '../components/preferences/RegionalSettings';
import SystemSettings from '../components/preferences/SystemSettings';

const Preferences = () => {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      
      <div className="flex-1 flex flex-col">
        <Header />
        
        <main className="flex-1 p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
              <Settings className="w-5 h-5 text-purple-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Preferences</h1>
              <p className="text-gray-600">Customize your application experience</p>
            </div>
          </div>

          <div className="space-y-6">
            <AppearanceSettings />
            <RegionalSettings />
            <SystemSettings />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Preferences;